import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useAxios } from '../../../hooks/useAxios';
import { useNavigate } from "react-router-dom";
import './blogs.css';

const Blogs = () => {

    const [t, i18n] = useTranslation("home");
    const [g] = useTranslation("global");

    const { data, isloading } = useAxios(
        `https://www.ricardosalinas.com/S8JFmpfeLW5iUVROXz2owTPU/api/blogs/n?offset=0&next=3&lang=${i18n.language}`
    );

    const liga_lang = '/' + i18n.language + "/Mi-blog#top_blogs";
    const [blogs, setBlogs] = useState(null);
    const navigate = useNavigate();

    const numero = (txtresumen) => {
        if (typeof txtresumen === 'string' && txtresumen.trim() !== '') {
            const partes = txtresumen.split("||");
            if (partes.length > 1 && partes[1].trim() !== "") {
                return partes[1].trim();
            }
        }
        return Math.floor(Math.random() * 4) + 1;
    };

    const resumensplit = (txtresumen) => {
        if (typeof txtresumen === 'string' && txtresumen.trim() !== '') {
            const partes = txtresumen.split("||");
            if (partes.length > 1 && partes[0].trim() !== "") {
                return partes[0].trim();
            }
        }
        return txtresumen;
    };

    useEffect(() => {
        if (data) {
            setBlogs(data);
        }
    }, [data]);

    const formatDate = (date) => {
        return new Date(date).toLocaleDateString('es-MX');
    };

    if (isloading || blogs === null) {
        return <div>Is loading...</div>;
    }

    return (
        <div className="_ngcontent-ng-c3910305518=">
              <section aria-labelledby="about-latest-title" class="about-latest">
                <section class="about-latest__posts">
                  <h2 id="about-latest-title" class="about-latest__heading">{g("general.entries-title")}</h2>
                  <div class="about-latest__grid">

                  {[0, 1, 2].map((i) => (
                        <a  href={'/blog/' + blogs[i].tag} key={i} className="about-latest-card" tabIndex="0">
                            <p className="about-latest-card__tag">{blogs[i].categorias[0].nombre}</p>
                            <h2 className="about-latest-card__title">{blogs[i].titulo}</h2>

                            {i !== 3 && (
                                <p className="about-latest-card__summary">
                                    {resumensplit(blogs[i].resumen)}
                                </p>
                            )}
                        </a>
                    ))}
                  </div>
                </section>
                <div class="about-latest__actions"><button
                    type="button" class="about-latest__more" onClick={() => window.location.href = liga_lang}>{g("general.all-entries")}</button></div>
              </section>
            </div>
    );
};

export default Blogs;